import { useEffect } from 'react';
import { Grid, Header, Segment } from 'semantic-ui-react';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../app/stores/store';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import PermitDetailedSidebar from './PermitDetailedSidebar';
import PermitDetailedInfo from './PermitDetailedInfo';
import { FaShuttleVan, FaCarSide } from 'react-icons/fa';

interface Props {
    permitId: string,
}

export default observer(function PermitDetails({ permitId }: Props) {
    const {userStore, permitStore} = useStore();
    const {
        loadPermit,
        loadingInitial,
        permit,
    } = permitStore;
    const { user } = userStore;

    useEffect(() => {
        if (permitId) loadPermit(permitId);
    }, [permitId, loadPermit]);

    if (loadingInitial || !permit) return <LoadingComponent content='loading permits...' />;

    return (
        <>
          <Segment attached>
                <Grid>
                    <Grid.Column width={16} className='no-padding-top no-padding-bottom'>
                        <Segment basic>
                            <Header 
                                as='h1'
                                color='teal' 
                                block
                            >
                                {permit.permitTypeId === 2 ? (
                                    <>
                                        <FaCarSide className='custom-icon inline' />
                                        <Header.Content>Carpool Permit</Header.Content>
                                    </>
                                ) : (
                                    <>
                                        <FaShuttleVan className='custom-icon inline' />
                                        <Header.Content>Vanpool Permit</Header.Content>
                                    </>
                                )}
                            </Header>
                        </Segment>
                    </Grid.Column>
                    <Grid.Column computer={6} tablet={6} mobile={16} className='no-padding-top'>
                        <PermitDetailedSidebar permit={permit} user={user!} />
                    </Grid.Column>
                    <Grid.Column computer={10} tablet={10} mobile={16} className='no-padding-top'>
                        <PermitDetailedInfo permit={permit} />
                    </Grid.Column>
                </Grid>
            </Segment>
        </>
    )
})